/**
 * 埋点事件
 * https://playfordream.yuque.com/docs/share/481ee9ac-acc3-4b9f-81d8-6ee546980f84?#GDuu
 */
export const TrackEvents = {
  // v1.17
  YPMS_Cashier_Payment_Generate_click: 'YPMS_Cashier_Payment_Generate_click', // 收银台付款单生成
  YPMS_Cashier_Payment_Download_click: 'YPMS_Cashier_Payment_Download_click', // 收银台付款单下载
  YPMS_Cashier_Payment_Print_click: 'YPMS_Cashier_Payment_Print_click', // 收银台付款单打印
  YPMS_Cashier_Payment_Copy_click: 'YPMS_Cashier_Payment_Copy_click', // 收银台付款单复制链接
  YPMS_Payment_view: 'YPMS_Payment_view', // 付款单展现数
  YPMS_Payment_Pay_click: 'YPMS_Payment_Pay_click', // 付款单支付按钮点击
  // v1.18.1
  YPMS_Home_Course_click: 'YPMS_Home_Course_click', // 使用教程按钮点击
  YPMS_Home_CustomerService_click: 'YPMS_Home_CustomerService_click', // 咨询门服按钮点击
  // v1.19
  YPMS_Computer_powon_click: 'YPMS_Computer_powon_click', // 电脑列表执行开机
  YPMS_Computer_powoff_click: 'YPMS_Computer_powoff_click', // 电脑列表执行关机
  YPMS_Computer_record_click: 'YPMS_Computer_record_click', // 电脑列表使用记录
  YPMS_Computer_detailed_click: 'YPMS_Computer_detailed_click', // 电脑列表电脑详情
};
